import { useMemo } from 'react';

import { EditorState } from 'draft-js';

import { getAllReplaceableEntities, getAllMentionEntities } from 'services/helpers/post';

export interface UseHelpMeWriteTooltipProps {
  editorState: EditorState;
  checkMention?: boolean;
}

const useHelpMeWriteTooltip = ({ editorState, checkMention = true }: UseHelpMeWriteTooltipProps) => {
  const { textContentLength, noOfMentions } = useMemo(() => {
    const allTextLength = editorState.getCurrentContent().getPlainText('\n').length;
    const allEntities = getAllReplaceableEntities(editorState);
    const mentionEntities = getAllMentionEntities(editorState);
    const allEntitiesLength = allEntities.reduce((acc, e) => acc + e.entityData.mention.name.length + 1, 0);
    return {
      textContentLength: allTextLength - allEntitiesLength,
      noOfMentions: mentionEntities.length,
    };
  }, [editorState]);

  if (textContentLength >= 15 && (!checkMention || noOfMentions)) {
    return {
      tooltip: 'Improve the quality of your feedback by leveraging Maven. Currently supports English only.',
      isDisabled: false,
      textContentLength,
    };
  }
  if (textContentLength >= 15 && checkMention && !noOfMentions) {
    return {
      tooltip: 'Tag at least one person to leverage Maven. Currently supports English only.',
      isDisabled: true,
      textContentLength,
    };
  }
  if (textContentLength < 15 && (!checkMention || noOfMentions)) {
    return {
      tooltip: 'Add more text to leverage Maven. Currently supports English only.',
      isDisabled: true,
      textContentLength,
    };
  }
  return {
    tooltip: 'Tag at least one person and add more text to leverage Maven. Currently supports English only.',
    isDisabled: true,
    textContentLength,
  };
};

export default useHelpMeWriteTooltip;
